import { useMutation, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IShowPdfForSubcontractorButton {
  id: string;
}

const ShowPdfForSubcontractorButton = ({
  id,
}: IShowPdfForSubcontractorButton) => {
  const notify = useNotify();

  const [getPdfUrlForSubcontractor, { loading }] = useMutation(
    {
      type: "getOne",
      resource: `subcontractorPurchaseInvoices`,
      payload: { id: id },
    },
    {
      onSuccess: ({ data }) => {
        if (data.pdfUrlForSubcontractor) {
          window.open(data.pdfUrlForSubcontractor, "_blank");
        } else {
          notify("The PDF Url for Subcontractor doesn't exist.", "warning");
        }
      },
      onFailure: (error) => {
        notify(
          `The PDF Url for Subcontractor doesn't exist. error: ${error.message}`,
          "warning",
        );
      },
    },
  );

  return (
    <StyledButton
      onClick={() => getPdfUrlForSubcontractor()}
      variant="outlined"
    >
      {loading ? "Loading" : `Show PDF Subcontractor`}
    </StyledButton>
  );
};

export default ShowPdfForSubcontractorButton;
